<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="380px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-form-item   prop="name" label="组织名称">
                    <el-input v-model="form.name" maxlength="200" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item   prop="deptControllerLabel" label="组织负责人">
                     <el-input placeholder="请选择人名" :readonly="true" v-model="form.deptControllerLabel" style="width: 200px;" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search" @click="findUser()"></el-button>
                    </el-input>
                </el-form-item>

                <el-form-item   prop="orderNum" label="排序号">
                    <el-input v-model="form.orderNum" maxlength="2" type="number"  style="width: 200px;"></el-input>
                </el-form-item>
            
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取消</el-button>
                <el-button type="primary" @click="save()">确定</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import userTransfer from '../user/UserTransfer.vue';

    export default {
        data(){
            return{
                visible: false,
                isNature:false,
                transferVisible:false,
                form:{
                    id:"",
                    name:"",
                    belongSubsectionid:"",
                    deptController:"",
                    deptControllerLabel: "",
                    orderNum:1
                },
                natures: [{
                    value: 1,
                    label: '幼儿园'
                }, {
                    value: 2,
                    label: '小学'
                }, {
                    value: 3,
                    label: '中学'
                }
                ],
                rules: {
                    name: [
                        { required: true, message: '请输入组织名称', trigger: 'blur' }
                    ]
                }
            }
        },
        components: {
            userTransfer
        },
        created:function () {
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                //初始值
                if(this.$util.isNotEmpty(data)){
                    this.form.id = data.id;
                    this.form.name = data.text;
                    this.form.deptController = data.attributes.deptController;
                    this.form.deptControllerLabel = data.attributes.deptControllerName;
                    this.form.belongSubsectionid=data.attributes.belongSubsectionid;
                    this.form.orderNum = data.attributes.orderNum;
                }
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.deptUpdateUrl;
                        let data = {
                            id:this.form.id,
                            name:this.form.name,
                            deptController:this.form.deptController,
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status == 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            },
            findUser(){
                this.transferVisible=true;
                this.$nextTick(() => {
                    if(this.$util.isNotEmpty(this.form.deptController)){
                        let val=new Array();
                        val.push(this.form.deptController);
                        this.$refs['userTransfer'].init(2,val,1,this.form.belongSubsectionid);
                    }else{
                        this.$refs['userTransfer'].init(2,null,1,this.form.belongSubsectionid);
                    }
                })
            },
            setUser(key,label){
                this.form.deptController = key;
                this.form.deptControllerLabel = label;
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/sys/dept/SetSchoolDeptUpdate.vue